'use strict'

// var app = angular.module('app');

module.exports = function (ngModule) {
  ngModule.service('Basic', ["$rootScope", "$http", "$window", "$log", function ($rootScope, $http, $window, $log) {
    var status = ''
    var allLicense = {}
    var allBundles = []
    var downloadPageMessage = {
      'redeem': 'Redeem Valid! Add one license to your account',
      'payment': 'Purchase successful!'
    }

    this.setupLicense = function (cb) {
      var url = '/api/products'

      $http
        .get(url)
        .success(function (data) {
          if (data.bundle && Array.isArray(data.product)) {
            data.product.forEach(function (ele) {
                  // setup license object
              if (!allLicense[ele.name]) {
                allLicense[ele.name] = {}
              }
              switch (~~ele.addition) {
                case 0:
                  allLicense[ele.name]['pro'] = ele
                  break
                case 1:
                  allLicense[ele.name]['demo'] = ele
                  break
                case 2:
                  allLicense[ele.name]['std'] = ele
                  break
              }
            })

            allBundles = data.bundle

            cb(null, data)
          } else {
            cb(new Error('Empty license list'))
          }
        })
        .error(function (err) {
          $log.error(err)
          cb(err)
        })
    }

    this.getStandardLicense = function (productType) {
      if (!allLicense[productType] || !allLicense[productType]['std']) {
        return false
      } else {
        return allLicense[productType]['std']
      }
    }

    this.getProfessionalLicense = function (productType) {
      if (!allLicense[productType] || !allLicense[productType]['pro']) {
        return false
      } else {
        return allLicense[productType]['pro']
      }
    }

    this.getLicenseType = function (pid) {
      if (allLicense['bias']) {
        if (pid === allLicense['bias']['pro']['id']) {
          return {name: 'BIAS Desktop', type: 'Professional', dltype: 'bias'}
        } else if (pid === allLicense['bias']['std']['id']) {
          return {name: 'BIAS Desktop', type: 'Standard', dltype: 'bias'}
        }
      }

      if (allLicense['live']) {
        if (pid === allLicense['live']['pro']['id']) {
          return {name: 'BIAS FX Desktop', type: 'Professional', dltype: 'live'}
        } else if (pid === allLicense['live']['std']['id']) {
          return {name: 'BIAS FX Desktop', type: 'Standard', dltype: 'live'}
        }
      }

      return false
    }

    this.getAllLicense = function (productType) {
      if (productType && productType in allLicense) {
        return allLicense[productType]
      } else {
        return allLicense
      }
    }

    this.getBundles = function () {
      return allBundles
    }

    this.setStatus = function (input) {
      status = input
    }

    this.getStatus = function () {
      return status
    }

    this.getDownloadMessage = function () {
      var message = downloadPageMessage[this.getStatus()]
      return (message) || ''
    }

    this.getOsName = function () {
      if (navigator.appVersion.indexOf('Win') !== -1) {
        return 'Windows'
      } else if (navigator.appVersion.indexOf('Mac') !== -1) {
        return 'MacOS'
      } else {
        return 'None'
      }
    }

    this.sendTrackToAdword = function (id, format, label, color, value, currency) {
      if ($window.google_trackConversion) {
        var trackData = {
          google_conversion_id: id,
          google_conversion_language: 'en',
          google_conversion_format: format,
          google_conversion_color: color,
          google_conversion_label: label,
          google_remarketing_only: false
        }
        if (value) {
          trackData['google_conversion_value'] = value
        }
        if (currency) {
          trackData['google_conversion_currency'] = currency
        }
        $log.debug(trackData)
        $window.google_trackConversion(trackData)
      }
    }

    this.dataURItoBlob = function (dataURI) {
      var binary = atob(dataURI.split(',')[1])
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
      var array = []
      for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i))
      }
      return new Blob([new Uint8Array(array)], {type: mimeString})
    }
  }])

  ngModule.factory('Auth', ["$rootScope", "$location", "Base64", "$http", "$httpParamSerializerJQLike", "$log", "$cookies", "$q", "$auth", "Upload", function ($rootScope, $location, Base64, $http, $httpParamSerializerJQLike, $log, $cookies, $q, $auth, Upload) {
  // initialize to whatever is in the cookie, if anything
  // $http.defaults.headers.common['Authorization'] = 'Basic ' + $cookies.get('authdata');
    var userLicenses = []
    var userOwnProduct = []

  // current support type: normal, fb
    var accountType = ''

    function resetLicenseArr () {
      userLicenses = {}
    }

    function assignUserLicense (data) {
      var hasProLicense = false
      data.forEach(function (item) {
        if (!userLicenses[item.product.name]) {
          userLicenses[item.product.name] = {}
        }

        var licenseType = ''
        switch (~~item.product.addition) {
          case 0:
            licenseType = 'pro'
            break
          case 1:
            licenseType = 'demo'
            break
          case 2:
            licenseType = 'std'
            break
        }
        if (!userLicenses[item.product.name][licenseType]) {
          userLicenses[item.product.name][licenseType] = []
        }
        userLicenses[item.product.name][licenseType].push(item)

        if (userOwnProduct.indexOf(item.product.id) === -1) {
          userOwnProduct.push(item.product.id)
        }
      })
    }

    return {
    // 0: no std license, cannot upgrade
    // 1: has std license
    // 2: has pro license, do not need to upgrade
      getUpgradeStatus: function (productType) {
        var upgradeType = 0
        if (userLicenses[productType]) {
          if (userLicenses[productType]['pro']) {
            upgradeType = 2
          } else if (!userLicenses[productType]['std']) {
            upgradeType = 0
          } else if (userLicenses[productType]['std'] &&
                (!userLicenses[productType]['pro'])) {
            upgradeType = 1
          }
        }
        $log.debug('user upgrade status: ' + upgradeType)
        return upgradeType
      },
      getUpgradeList: function (products) {
        var list = {};

        ['bias', 'live'].forEach(function (pname) {
          if (userLicenses[pname] && userLicenses[pname]['std'] && !userLicenses[pname]['pro']) {
            list[pname] = {
              from: products[pname]['std']['display_name'],
              fromPid: products[pname]['std']['id'],
              to: products[pname]['pro']['display_name'],
              toPid: products[pname]['pro']['id'],
              price: products[pname]['std']['upgrade']['price']
            }
          }
        })

        return list
      },
      getDownloadList: function (products) {
        var list = [];

        ['bias', 'live'].forEach(function (pname) {
          if (userLicenses[pname] && (userLicenses[pname]['std'] || userLicenses[pname]['pro'])) {
            list.push({
              display_name: products[pname]['std']['display_name']
            })
          }
        })

        return list
      },
      getUserThumbnail: function () {
        return ($cookies.get('pgicon')) ? $cookies.get('pgicon') : null
      },
      setUserThumbnail: function (picUrl) {
        if (picUrl) {
          $cookies.get('pgicon', picUrl, { expires: 30 })
        }
        $rootScope.$broadcast('user:icon')
      },
      getUserLicense: function (cb) {
        $http
      .get('/api/license')
      .success(function (data) {
        $log.debug(data)
        resetLicenseArr()
        if ('data' in data && Array.isArray(data.data)) {
          if (data.result === true) {
            $rootScope.$emit('updateUserData')
            assignUserLicense(data.data)
            cb(null, userLicenses)
          } else {
            cb(new Error('Fetch license error'))
          }
        } else {
          cb(new Error('Wrong license format'))
        }
      })
      .error(function (err) {
        cb(err)
      })
      },
      checkUserLicense: function (productType) {
        if ($rootScope.turnOnBiasFx) { return true }

        return !($.isEmptyObject(userLicenses[productType]))
      },
      hasLicense: function (productType) {
        return !!(userLicenses[productType])
      },
      hasStandardLicense: function (productType) {
      // return (standardLicense.length > 0) ? true : false;
        return !!((userLicenses[productType] &&
        userLicenses[productType]['std']))
      },
      hasProfessionalLicense: function (productType) {
      // return (professionalLicense.length > 0) ? true : false;
        return !!((userLicenses[productType] &&
        userLicenses[productType]['pro']))
      },
      getOneStandard: function (productType) {
        if (userLicenses[productType] &&
        userLicenses[productType]['std']) {
          var license = userLicenses[productType]['std'][0]
          return license.id
        }
        return false
      },
      hasTargetProduct: function (pId, allLicenses) {
        var targetProduct = {}
        Object.keys(allLicenses).forEach(function (product) {
          Object.keys(allLicenses[product]).forEach(function (license) {
            var item = allLicenses[product][license]
            if (item.id === pId) {
              targetProduct = item
            }
          })
        })
        $log.debug(targetProduct)

        return !!((targetProduct.name in userLicenses &&
        parseInt(targetProduct.addition, 10) !== 1))
      },
      setCredentials: function (username, password, loginSuccess, useFb) {
        var encoded = Base64.encode(username + ':' + password)
      // $http.defaults.headers.common.Authorization = 'Basic ' + encoded;

        if (loginSuccess) {
          accountType = 'normal'
          $rootScope.alreadyLogin = true
          $rootScope.loginUser = username
          var expiredDate = new Date(new Date().getTime() + (86400000 * 30))
          $cookies.put('authdata', encoded, { expires: expiredDate })
        }

        if (useFb !== undefined && typeof (useFb) === 'boolean') {
          accountType = 'fb'
        }
      },
      clearCredentials: function () {
        $rootScope.$emit('updateUserData')
        $cookies.remove('authdata')
        $cookies.remove('pgicon')
        $rootScope.alreadyLogin = false
        accountType = ''
        resetLicenseArr()
      // $http.defaults.headers.common.Authorization = 'Basic ';
      },
      getAccountType: function () {
        return accountType
      },
      loginUser: function (token) {
        $auth.setToken(token)
        $cookies.put('pg_auth_token', token)
        $rootScope.alreadyLogin = true
        $log.debug('loginUser', token, $auth.getToken())
      },
      logoutUser: function () {
        $location.search('')
        $auth.removeToken()
        $cookies.remove('pg_auth_token')
        $rootScope.alreadyLogin = false
      },
      getJwt: function () {
        if ($auth.getToken()) {
          return $auth.getToken()
        } else if ($cookies.get('pg_auth_token')) {
          return $cookies.get('pg_auth_token')
        } else {
          return false
        }
      },
      checkLoginStatus: function () {
        var deferred = $q.defer()
        var self = this

        var authData = this.getJwt()
        if (!authData) {
          $log.debug('checkLoginStatus:no_auth')
          deferred.reject(false)
        } else {
          self.getUser()
          .then(function (data) {
            $log.debug('checkLoginStatus:success')
            deferred.resolve(data)
          })
          .catch(function (err) {
            $log.debug('checkLoginStatus:fail')
            self.logoutUser()
            deferred.reject(err)
          })
        }

        return deferred.promise
      },
      isLoggedIn: function () {
        var authData = this.getJwt()
        $log.debug('isLoggedIn', authData)

        if (authData) {
          $rootScope.alreadyLogin = true
          return true
        } else {
          $rootScope.alreadyLogin = false
          return false
        }
      },
      getJwtHeader: function () {
        var token = this.getJwt()
        if (token !== false) {
          return {
            Authorization: 'JWT ' + token
          }
        } else {
          return false
        }
      },
      getUser: function () {
        var token = this.getJwtHeader()
        return $http({
          method: 'GET',
          url: '/api/all_users',
          headers: token
        })
      },
      userLogin: function (loginData, authType, queryParams) {
        var self = this
        var queryObj = {
          method: 'POST',
          url: '/api/auth',
          data: loginData
        }

        switch (authType) {
          case 'big_commerce':
            queryObj['params'] = {
              'auth_type': 'bc'
            }
            if (_.has(queryParams, 'redirect_to')) {
              queryObj['params']['redirect_to'] = queryParams['redirect_to']
            }
            if (_.has(queryParams, 'redirect_host')) {
              queryObj['params']['redirect_host'] = queryParams['redirect_host']
            }
            queryParams['redirect'] = 'bc'
            break
          case 'account':
            queryObj['params'] = {
              'auth_type': 'account'
            }
            if (!_.has(queryParams, 'redirect')) {
              queryParams['redirect'] = 'account'
            }
            break
        }

        queryObj['params']['region'] = queryParams['region']

        return $q(function (resolve, reject) {
          $http(queryObj).then(function (resp) {
            if (resp.status === 200 && resp.data && resp.data.token) {
              if (authType !== 'big_commerce') {
                self.loginUser(resp.data.token)
              }
              resolve(resp.data)
            } else {
              reject(new Error('Login data return from server invalid'))
            }
          }).catch(function (err) {
          // redirect user to first/last name page
            if (_.has(err, 'data.code') && err.data.code === 'NEED_MIGRATE_BC_FORMAT') {
              self.loginUser(err.data.token)
              $location.path('/update_profile').search(queryParams)
              reject('need migrate your account to new format')
            } else {
              var errorMessage = (err.data && (err.data.code || err.data.errorMessage))
              ? err.data.code.toUpperCase() || err.data.errorMessage
              : 'Login failed'

              reject(errorMessage)
            }
          })
        })
      },
      migrateFirstLastName: function (userData, queryParams) {
        var postData = _.assign({}, userData, { query: queryParams })
        $log.debug('migrateBC', postData)
        return $http({
          method: 'PUT',
          url: '/v2/user/migrate_bc_account',
          data: postData,
          headers: this.getJwtHeader()
        })
      },
      userSignup: function (userData, version) {
        if (version && version === 'v2') {
          return $http({
            method: 'POST',
            url: '/v2/user',
            data: userData
          })
        } else {
          return $http({
            method: 'POST',
            url: '/api/user',
            data: userData
          })
        }
      },
      userActivation: function (activateData) {
        return $http({
          method: 'POST',
          url: '/api/user/activate',
          data: activateData
        })
      },
      updateUserData: function (userData, updateType) {
        var self = this
        if (updateType === 'b2b') {
          return $http({
            url: '/api/b2b_info',
            method: 'PUT',
            headers: self.getJwtHeader(),
            data: userData
          })
        } else {
          return Upload.upload({
            url: '/v2/user',
            method: 'PUT',
            headers: self.getJwtHeader(),
            data: userData
          })
        }
      },
      doReqReset: function (userEmail) {
        var hostname = ($location.port() === 80 || $location.port() === 443)
        ? $location.protocol() + '://' + $location.host()
        : $location.protocol() + '://' + $location.host() + ':' + $location.port()

        $log.debug('api:doReqReset', userEmail, hostname)
        return $http({
          method: 'PUT',
          url: '/api/req_reset_pwd',
          data: $httpParamSerializerJQLike({
            user_email: userEmail,
            reset_form_host: hostname
          }),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
      }
    }
  }])

  ngModule.factory('Base64', function () {
    var keyStr = 'ABCDEFGHIJKLMNOP' +
        'QRSTUVWXYZabcdef' +
        'ghijklmnopqrstuv' +
        'wxyz0123456789+/' +
        '='
    return {
      encode: function (input) {
        var output = ''
        var chr1, chr2, chr3 = ''
        var enc1, enc2, enc3, enc4 = ''
        var i = 0

        do {
          chr1 = input.charCodeAt(i++)
          chr2 = input.charCodeAt(i++)
          chr3 = input.charCodeAt(i++)

          enc1 = chr1 >> 2
          enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
          enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
          enc4 = chr3 & 63

          if (isNaN(chr2)) {
            enc3 = enc4 = 64
          } else if (isNaN(chr3)) {
            enc4 = 64
          }

          output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4)
          chr1 = chr2 = chr3 = ''
          enc1 = enc2 = enc3 = enc4 = ''
        } while (i < input.length)

        return output
      },

      decode: function (input) {
        var output = ''
        var chr1, chr2, chr3 = ''
        var enc1, enc2, enc3, enc4 = ''
        var i = 0

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
        var base64test = /[^A-Za-z0-9\+\/\=]/g
        if (base64test.exec(input)) {
          alert('There were invalid base64 characters in the input text.\n' +
                    "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
                    'Expect errors in decoding.')
        }
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '')

        do {
          enc1 = keyStr.indexOf(input.charAt(i++))
          enc2 = keyStr.indexOf(input.charAt(i++))
          enc3 = keyStr.indexOf(input.charAt(i++))
          enc4 = keyStr.indexOf(input.charAt(i++))

          chr1 = (enc1 << 2) | (enc2 >> 4)
          chr2 = ((enc2 & 15) << 4) | (enc3 >> 2)
          chr3 = ((enc3 & 3) << 6) | enc4

          output = output + String.fromCharCode(chr1)

          if (enc3 != 64) {
            output = output + String.fromCharCode(chr2)
          }
          if (enc4 != 64) {
            output = output + String.fromCharCode(chr3)
          }

          chr1 = chr2 = chr3 = ''
          enc1 = enc2 = enc3 = enc4 = ''
        } while (i < input.length)

        return output
      }
    }
  })
}



//////////////////
// WEBPACK FOOTER
// ./js/services/auth.js
// module id = 57
// module chunks = 0